import { defineDepKeys, pickDeps } from "./depTools";

const AUTH_DEPS_KEYS = defineDepKeys([
  "syncFarmCollaboratorAccountsToEmployees",
  "getAccounts",
  "deriveAllowedModules",
  "normalizeModulePermissions",
  "normalizeCostCenterPermissions",
  "normalizeUiPreferences",
  "ensureDefaultAdminAccount",
  "saveAccounts",
  "pushGlobal",
  "DB",
  "ensureAdminAccountAvailable",
  "getPersistedAdminCredentialState",
  "readAdminPasswordOverride",
  "stripDeletedItems",
  "isFarmArchived",
  "T",
  "FarmEmoji",
  "PwInput",
  "Btn",
  "Input",
]);

function buildLoginScreenDeps(deps) {
  return pickDeps(deps, AUTH_DEPS_KEYS);
}

export { AUTH_DEPS_KEYS, buildLoginScreenDeps };
